<!--<div (click)="selectService.open()">
    <span>{{ placeholder }}</span>
    <app-button [config]="button" (click)="selectService.open()"></app-button>
</div>

<mat-select #selectService>
    <mat-optgroup *ngFor="let service of services" [label]="service.title" [disabled]="service.disabled">
        <mat-option *ngFor="let childService of service.childServices" [value]="childService.slug">
            {{childService.title}}
        </mat-option>
    </mat-optgroup>
</mat-select>-->

<div class="search-box" [class.micro]="micro">
    <form [formGroup]="searchForm">
        <input
            type="text"
            [placeholder]="placeholder"
            #selectService
            formControlName="servicePicker"
            [matAutocomplete]="autoGroup"
            (keydown.enter)="enterKeyCheck()"
            [matAutocompletePosition]="'below'"
        />
        <mat-autocomplete
            #autoGroup="matAutocomplete"
            [class]="micro ? 'micro' : null"
        >
            <mat-optgroup
                *ngFor="let service of serviceGroupOptions | async"
                [label]="service.title"
                (click)="pickService(service, null)"
            >
                <mat-option
                    *ngFor="let childService of service.childServices"
                    [value]="childService.title"
                    (click)="pickService(service, childService)"
                >
                    {{ childService.title }}
                </mat-option>
            </mat-optgroup>
        </mat-autocomplete>
        <app-button [config]="button" (click)="enterKeyCheck()"></app-button>
    </form>
</div>
